// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomLeafletTooltip_leafletTooltip__Zr2dK {
    background-color: var(--color-120);
    color: var(--color-106);
    border: 1px solid var(--color-120);
    width: max-content;
    max-width: 200px;
    /*same font as in tooltipModule*/
    font: 100 14px/22px 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 13px;
    border-radius: 2px;
    line-height: 1.5;
    text-align: center;
    transition: opacity 0.3s;
    margin-top: auto;
    margin-bottom: auto;
    display: inline-table;
    white-space: normal;
}

/*attribute classes taken from leaflet tooltip - global*/
.CustomLeafletTooltip_leafletTooltip__Zr2dK[class~="leaflet-tooltip-left"]:before {
    border-left-color:var(--color-120);
}
.CustomLeafletTooltip_leafletTooltip__Zr2dK[class~="leaflet-tooltip-right"]:before {
    border-right-color:var(--color-120);
}
.CustomLeafletTooltip_leafletTooltip__Zr2dK[class~="leaflet-tooltip-top"]:before {
    border-top-color:var(--color-120);
}
.CustomLeafletTooltip_leafletTooltip__Zr2dK[class~="leaflet-tooltip-bottom"]:before {
    border-bottom-color:var(--color-120);
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Maps/components/CustomLeafletTooltip.module.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,+EAA+E;IAC/E,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,wDAAwD;AACxD;IACI,kCAAkC;AACtC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,oCAAoC;AACxC","sourcesContent":[".leafletTooltip {\n    background-color: var(--color-120);\n    color: var(--color-106);\n    border: 1px solid var(--color-120);\n    width: max-content;\n    max-width: 200px;\n    /*same font as in tooltipModule*/\n    font: 100 14px/22px 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-size: 13px;\n    border-radius: 2px;\n    line-height: 1.5;\n    text-align: center;\n    transition: opacity 0.3s;\n    margin-top: auto;\n    margin-bottom: auto;\n    display: inline-table;\n    white-space: normal;\n}\n\n/*attribute classes taken from leaflet tooltip - global*/\n.leafletTooltip[class~=\"leaflet-tooltip-left\"]:before {\n    border-left-color:var(--color-120);\n}\n.leafletTooltip[class~=\"leaflet-tooltip-right\"]:before {\n    border-right-color:var(--color-120);\n}\n.leafletTooltip[class~=\"leaflet-tooltip-top\"]:before {\n    border-top-color:var(--color-120);\n}\n.leafletTooltip[class~=\"leaflet-tooltip-bottom\"]:before {\n    border-bottom-color:var(--color-120);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leafletTooltip": `CustomLeafletTooltip_leafletTooltip__Zr2dK`
};
export default ___CSS_LOADER_EXPORT___;
